import type { FacetsResponse, GetFacetsParams } from '@/types/catalog'
import * as apiBff from './bff'
import { createProductQueryParams } from './query-params'

export async function getFacets({ season, department, families, subdepartments, viewMode, productCode, filters = {}, isNew }: GetFacetsParams): Promise<FacetsResponse> {
  const params = createProductQueryParams({
    department,
    families,
    subdepartments,
    filters,
    productCode,
    isNew,
  })

  return apiBff.callBFF<FacetsResponse>(
    'GET',
    `season/${season}/${viewMode === 'sm' ? 'super-models' : 'models'}/facets?${params.toString()}`,
  )
}
